


























































import Vue from "vue";
import Component from "vue-class-component";
import { Watch, Prop } from "vue-property-decorator";
import * as pbi from "powerbi-client";
import _ from "lodash";
import Http, { Data } from "front-component/Http";

@Component({})
export default class PowerBiExport extends Vue {
    @Prop( { type: String, default: null }) public embedUuid!: string|null;
    @Prop( { type: String, default: null }) public reportUuid!: string;
    @Prop( { type: String, default: "export" }) public filename!: string;
    @Prop( { type: Object, default: null }) public report!: pbi.Report |null;
    @Prop( { type: Array, default: () => [] }) public pages!: pbi.Page[];

    private loading: boolean = true;
    private exportInProgress: boolean = false;
    private dialogVisible: boolean = false;
    private exportPercentage: number = 0;
    private selectedPagesIds: string[] = [];

    @Watch("report")
    public activateExport() {
        if (this.report) {
            this.report.on("loaded", () => {
                this.loading = false;
            });
        }
        this.selectedPagesIds = [];
    }

    get canExport() {
        return !this.dialogVisible && !this.exportInProgress;
    }

    get progressStatus() {
        return 100 === this.exportPercentage ? "success" : null;
    }

    get progressPercentage() {
        return 0 !== this.exportPercentage ? this.exportPercentage : 10;
    }

    protected showDialog() {
        this.dialogVisible = true;
    }

    protected closeDialog() {
        this.dialogVisible = false;
    }

    protected startExport() {
        this.$message(_.invoke(this.$options.filters, "trans", "powerBiExportStarted"));

        this.exportInProgress = true;
        this.exportPercentage = 0;
        this.dialogVisible = false;
    }

    protected endExport() {
        this.exportPercentage = 0;
        this.exportInProgress = false;
    }

    protected generateExport(format: string) {
        let id: string = "";
        const reportName = this.filename;
        const embedUuid = this.embedUuid;

        this.startExport();
        this.exportReport(format)
            .then((data: object[]) => {
                id = _.get(data, "id", "");
                return this.exportReportStatus(id, embedUuid);
            })
            .then((reportInitialStatusData: object[]) => {
                this.exportPercentage = _.get(reportInitialStatusData, "percentComplete", 0);

                if (100 === this.exportPercentage) {
                    this.exportDownload(id, this.reportUuid, format, reportName).then(() => {
                        this.endExport();
                    });
                }

                if (this.exportPercentage < 100) {
                    const timerId = setInterval(() => {
                        this.exportReportStatus(id, embedUuid).then((reportStatusData: object[]) => {
                            this.exportPercentage = _.get(reportStatusData, "percentComplete", 0);
                            if (100 === this.exportPercentage) {
                                clearInterval(timerId);
                                this.exportDownload(id, this.reportUuid, format, reportName).then(() => {
                                    this.endExport();
                                });
                            }
                        });
                    }, 5000);
                }
            })
            .catch(() => {
                this.endExport();
                this.$message({
                    type: "error",
                    message: _.invoke(this.$options.filters, "trans", "powerBiExportError"),
                });
            })
        ;
    }

    public async exportReport(format: string): Promise<any> {
        if (!this.embedUuid || !this.report) {
            return;
        }

        const bookmark: pbi.models.IReportBookmark = await this.report.bookmarksManager.capture({
            allPages: true,
            personalizeVisuals: true
        });
        const state = _.get(bookmark, "state", "");
        const exportedPages = this.selectedPages.length > 0 ? this.selectedPages : this.pages;
        const pagesData = JSON.stringify(_.map(
            exportedPages,
            ({ name, displayName }: pbi.Page) => {
                return { name, displayName };
            }
        ));

        const formData = new FormData();
        formData.append("reportUuid", this.reportUuid);
        formData.append("exportFormat", format);
        formData.append("bookmark", state);
        formData.append("pages", pagesData);

        return new Promise((resolve: (value: object) => void, reject) => {
            Http.create(
                "/powerbi-report-export",
                formData,
                (result: Data) => {
                    resolve(result.data);
                },
                reject
            );
        });
    }

    public exportReportStatus(reportId: string, embedUuid: string | null): Promise<any>|any {
        if (!embedUuid) {
            return;
        }

        const formData = new FormData();
        formData.append("reportUuid", this.reportUuid);
        formData.append("exportId", reportId);

        return new Promise((resolve: (value: object) => void, reject) => {
            Http.search(
                "/powerbi-report-export/status",
                formData,
                (result: Data) => {
                    resolve(result.data);
                },
                reject
            );
        });
    }

    public exportDownload(
        exportId: string,
        embedUuid: string | null,
        exportFormat: string,
        exportName: string
    ): Promise<any>|any {
        if (!embedUuid) {
            return;
        }

        const params = {
            reportUuid: this.reportUuid,
            exportId,
            exportFormat,
            exportName,
        };

        return new Promise((resolve: (value: object) => void, reject) => {
            Http.download(
                "/powerbi-report-export/download",
                params,
                (data: Blob) => {
                    const url = window.URL.createObjectURL(data);
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", exportName + "." + exportFormat);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    resolve(data);
                },
                reject
            );
        });

    }

    protected get selectedPages(): pbi.Page[] {
        return _.filter(this.pages, (page: pbi.Page) => {
            return _.includes(this.selectedPagesIds, page.name);
        });
    }
}
